/** Public marketing site base URL (no trailing slash), e.g. https://www.mysign.az */
export function getMarketingOrigin(): string {
  const raw = process.env.REACT_APP_MARKETING_ORIGIN;
  const base = (raw?.trim() || 'https://www.mysign.az').replace(/\/$/, '');
  return base;
}

/** Full URL on the marketing site, e.g. `/contact` → `https://www.mysign.az/contact` */
export function marketingUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${getMarketingOrigin()}${p}`;
}
